import { FC, useCallback } from 'react';
import { useFragment, useMutation } from 'react-relay';
import { Formik } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import Section from 'components/Section';
import AccordionController from 'components/AccordionController';
import TextField from 'components/TextField';
import Form from 'components/Form';

import { useErrorHandler } from 'lib';
import { RoomPropertyEditForm_roomProperty$key } from '__generated__/RoomPropertyEditForm_roomProperty.graphql';
import { RoomPropertyEditFormMutation } from '__generated__/RoomPropertyEditFormMutation.graphql';

type FormValues = {
  name: string;
  etgKey: string;
};

type Props = {
  roomProperty: RoomPropertyEditForm_roomProperty$key;
};

const RoomPropertyEditForm: FC<Props> = ({ roomProperty }) => {
  const errorHandler = useErrorHandler();

  const { id, name, etgKey } = useFragment(
    graphql`
      fragment RoomPropertyEditForm_roomProperty on RoomProperty {
        id
        name
        etgKey
      }
    `,
    roomProperty
  );

  const [update, loading] = useMutation<RoomPropertyEditFormMutation>(graphql`
    mutation RoomPropertyEditFormMutation(
      $id: ID!
      $input: UpdateRoomPropertyInput!
    ) {
      updateRoomProperty(id: $id, input: $input) {
        ...EntitySidebar_entity
        ...RoomPropertyEditForm_roomProperty
      }
    }
  `);

  const initial = {
    name: name ?? '',
    etgKey: etgKey ?? '',
  };

  const handleSubmit = useCallback(
    (input: FormValues) => {
      update({
        variables: { id, input },
        ...errorHandler({
          successMessage: 'Išsaugota',
        }),
      });
    },
    [errorHandler, id, update]
  );

  return (
    <Formik<FormValues> initialValues={initial} onSubmit={handleSubmit}>
      <Form loading={loading}>
        <AccordionController id="roomPropertyEdit">
          <Section id="main" title="Bendra informacija">
            <Stack spacing={4}>
              <TextField autoFocus name="name" label="Pavadinimas" fullWidth />
              <TextField name="etgKey" label="ETG ID" fullWidth />
            </Stack>
          </Section>
        </AccordionController>
      </Form>
    </Formik>
  );
};

export default RoomPropertyEditForm;
